import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1fdc4428"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  role: "alert"
}

import { watch } from 'vue'

// Custom components
import QBtnValid from '@components/form/QBtnValid.vue'
import QBtnClose from '@components/form/QBtnClose.vue'

// ViewModels
import {useBannerVersionVM} from '@components/banner/vmBannerVersion'
import {useGlobalVM} from '@viewmodel/global.vm'
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

/**
 * ViewModels
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BannerVersion',
  setup(__props) {

// Vendor
const {
    // Reactives
    showUpdateApplicationBanner,
    remoteVersion,
    validBtnLabel,

    // Methods
    enter,
    afterEnter,
    leave,
    onFullReload,
    init,
} = useBannerVersionVM()

const { isMobile } = useGlobalVM()

/**
 * Watch
 */
watch(() => sessionManager.isOnline.value, async (newVal: boolean | undefined, oldVal: boolean | undefined) => {
  if (newVal && !oldVal) {
    init()
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" <div @click=\"showUpdateApplicationBanner = !showUpdateApplicationBanner\" class=\"cursor-pointer\">CLICK</div> "),
    _createVNode(_Transition, {
      name: "expand",
      onEnter: _unref(enter),
      onAfterEnter: _unref(afterEnter),
      onLeave: _unref(leave)
    }, {
      default: _withCtx(() => [
        (_unref(showUpdateApplicationBanner))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_q_banner, {
                "inline-actions": !_unref(isMobile),
                class: "bg-primary text-white q-mb-md"
              }, {
                action: _withCtx(() => [
                  _createVNode(QBtnValid, {
                    onClick: _unref(onFullReload),
                    label: _unref(validBtnLabel)
                  }, null, 8 /* PROPS */, ["onClick", "label"]),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createBlock(_component_q_space, {
                        key: 0,
                        class: "q-px-sm"
                      }))
                    : _createCommentVNode("v-if", true),
                  _createVNode(QBtnClose, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (showUpdateApplicationBanner.value = false))
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" Nouvelle version disponible (v" + _toDisplayString(_unref(remoteVersion)) + ") ", 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["inline-actions"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onEnter", "onAfterEnter", "onLeave"])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})